import { useState } from "react";
import { Link } from "react-router-dom";
import { Send, Check, Loader2, Gift } from "lucide-react";
import { api } from "@/lib/api";

export default function NewsletterSignup() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // idle | loading | done

  const submit = async (e) => {
    e.preventDefault();
    if (!email || status === "loading") return;
    setStatus("loading");
    try {
      await api.post("/newsletter/subscribe", { email });
      setStatus("done");
      setEmail("");
    } catch {
      setStatus("idle");
    }
  };

  return (
    <section className="bg-ink text-bone py-20 lg:py-28" data-testid="newsletter-section">
      <div className="max-w-[900px] mx-auto px-6 lg:px-10 text-center">
        <p className="text-[11px] uppercase tracking-[0.3em] text-claret-soft mb-5">La newsletter</p>
        <h2 className="font-serif-display text-4xl lg:text-5xl leading-[1.05]">Vuoi scoprire cosa stiamo bevendo?</h2>
        <p className="text-bone/60 mt-4 text-base lg:text-lg">Nuovi arrivi, produttori, occasioni e qualche consiglio.</p>

        <div data-testid="newsletter-welcome-perk" className="mt-6 inline-flex items-center gap-2.5 border border-claret-soft/40 bg-claret/15 px-5 py-2.5 text-sm text-bone">
          <Gift size={16} className="text-claret-soft shrink-0" />
          <span>
            Registrati e ricevi un <strong>codice sconto del 10%</strong> sul primo ordine.{" "}
            <Link to="/register" data-testid="newsletter-register-link" className="underline underline-offset-2 hover:text-claret-soft transition-colors">Crea un account</Link>
          </span>
        </div>

        {status === "done" ? (
          <div className="mt-10 inline-flex items-center gap-3 text-bone" data-testid="newsletter-success">
            <span className="w-10 h-10 rounded-full bg-claret flex items-center justify-center"><Check size={20} /></span>
            Iscrizione confermata. A presto!
          </div>
        ) : (
          <form onSubmit={submit} className="mt-10 flex flex-col sm:flex-row gap-3 max-w-md mx-auto" data-testid="newsletter-form">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="La tua email"
              data-testid="newsletter-email"
              className="flex-1 bg-transparent border border-bone/30 focus:border-bone outline-none px-5 py-4 text-bone placeholder:text-bone/40 transition-colors"
            />
            <button
              type="submit"
              disabled={status === "loading"}
              data-testid="newsletter-submit"
              className="inline-flex items-center justify-center gap-2 bg-claret hover:bg-claret-dark text-bone px-8 py-4 uppercase tracking-[0.15em] text-sm transition-colors disabled:opacity-60"
            >
              {status === "loading" ? <Loader2 size={18} className="animate-spin" /> : <Send size={16} />} Iscriviti
            </button>
          </form>
        )}
      </div>
    </section>
  );
}
